import React from 'react';
import {
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItemOption,
  MenuOptionGroup,
} from '@chakra-ui/react';
import { MdExpandMore } from 'react-icons/md';
import { t } from '#i18n';
import { useAccount } from '#contexts/account';
import { useRepositoriesQuery } from '#hooks/useRepositoriesQuery';

export const RepositorySelect = ({ repositoryIds, onChange }) => {
  const { currentInstallation } = useAccount();
  const { repositories } = useRepositoriesQuery({
    profileId: currentInstallation?.profile.id,
    status: 'ACTIVE',
  });

  const allSelected = !repositoryIds.length;

  const handleSelectAll = () => onChange([]);

  return (
    <Menu closeOnSelect={false}>
      <MenuButton
        as={Button}
        aria-label={t('stats.repositorySelect.selectLabel')}
        minWidth={40}
        backgroundColor="primary.400"
        borderColor="primary.300"
        variant="outline"
        fontWeight="normal"
        rightIcon={<MdExpandMore />}
      >
        {t('stats.repositorySelect.selectedRepositories', { count: repositoryIds.length })}
      </MenuButton>
      <MenuList
        maxHeight="300px"
        overflowY="scroll"
        sx={{
          '&::-webkit-scrollbar': {
            width: '4px',
            borderRadius: '8px',
            backgroundColor: 'rgba(0, 0, 0, 0.05)',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'primary.200',
          },
        }}
      >
        <MenuItemOption
          value="all"
          fontWeight="semibold"
          isChecked={allSelected}
          onClick={handleSelectAll}
        >
          {t('stats.repositorySelect.selectAll')}
        </MenuItemOption>
        <MenuOptionGroup type="checkbox" onChange={onChange} value={repositoryIds}>
          {repositories?.map((repository) => (
            <MenuItemOption
              key={repository.id}
              value={repository.id}
            >
              {repository.name}
            </MenuItemOption>
          ))}
        </MenuOptionGroup>
      </MenuList>
    </Menu>
  );
};
